var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{attrs:{"title":_vm.$t(("settingsPage.edit" + (_vm.isCompanyAccount ? 'Representative' : 'Personal') + "Info"))}},[_c('PersonalDataForm',{on:{"next":_vm.done}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }